import axios from "axios";
import { unpublishedProjectsUrl } from "../utils";

export const fetchUnpublishedProjects = async () => {
  return await axios.get(unpublishedProjectsUrl());
};
